import { render } from "./LastPublicationWrapper.vue?vue&type=template&id=6f3c5c48"
import script from "./LastPublicationWrapper.vue?vue&type=script&lang=js"
export * from "./LastPublicationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__